import { useState } from "react";
import MultiSelectDropdown from "./selectableDropdown"; // Assuming this is the correct import
import { IoSearchOutline } from "react-icons/io5";

const PageHeaders = ({
  title,
  buttonLable = "Create",
  searchPlaceHolder = "Search here",
  onClickButton,
  handleInputChange,
  buttons,
  action,
}) => {
  const [active, setActive] = useState(0);

  return (
    <div className="p-4 flex items-center gap-5 justify-between">
      {/* Left Section */}
      <div className="flex items-center gap-9">
        <h2 className="text-orange-500 font-semibold text-3xl left-2 ">
          {title}
        </h2>
      </div>

      {/* Right Section */}
      <div className="flex items-right justify-right gap-5">
        <div className="flex items-center justify-between pr-2 rounded-lg border-orange-400 border w-fit">
          <input
            type="text"
            placeholder="Search"
            className="w-full py-2 pl-4 pr-10 text-sm outline-none text-gray-600 rounded-lg"
            onChange={handleInputChange}
          />
          <IoSearchOutline className="text-primary" />
        </div>
        {/* Multi-select dropdown */}
        {/* <MultiSelectDropdown 
          options={buttons} 
          onChange={onClickButton} 
        /> */}
        <select
          className="focus:outline-none border border-primary rounded-lg p-2 pr-4"
          onChange={action}
        >
          {buttons.map((button) => (
            <option value={button.id}>{button.name}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default PageHeaders;
